function loadCSS(cdnUrl) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cdnUrl;
    link.type = 'text/css';
    document.head.appendChild(link); // Adds the link to the document head
}

loadCSS('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.1/css/all.min.css');

let start = new Date().getTime();

const originPosition = { x: 0, y: 0 };

const last = {
  starTimestamp: start,
  starPosition: originPosition,
  mousePosition: originPosition
};
const colors = [
  "255, 173, 173",
  "255, 214, 165",
  "253, 255, 182",
  "202, 255, 191",
  "155, 246, 255",
  "155, 246, 255",
  "160, 196, 255",
  "189, 178, 255",
  "255, 198, 255"
];
const config = {
  starAnimationDuration: 1500,
  minimumTimeBetweenStars: 250,
  minimumDistanceBetweenStars: 75,
  glowDuration: 75,
  maximumGlowPointSpacing: 10,
  colors: colors,
  sizes: ["1.6rem", "1.2rem", "0.8rem"],
  animations: ["fall-1", "fall-2", "fall-3"]
};

let count = 0;

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min,
  selectRandom = (items) => items[rand(0, items.length - 1)];

const withUnit = (value, unit) => `${value}${unit}`,
  px = (value) => withUnit(value, "px"),
  ms = (value) => withUnit(value, "ms");

const calcDistance = (a, b) => {
  const diffX = b.x - a.x,
    diffY = b.y - a.y;

  return Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
};

const calcElapsedTime = (start, end) => end - start;

const appendElement = (element) => document.body.appendChild(element),
  removeElement = (element, delay) =>
    setTimeout(() => document.body.removeChild(element), delay);

const createGlowPointPosition = ({ x, y }) => {
  return {
    x: x + 10,
    y: y + 20
  };
};
const icons = ["star fa-solid fa-star", "star fa-solid fa-heart"]

const createStar = (position) => {
  const star = document.createElement("span"),
    color = selectRandom(config.colors);

  star.className = selectRandom(icons);
  const { x, y } = createGlowPointPosition(position);
  star.style.left = px(x);
  star.style.top = px(y);
  star.style.fontSize = selectRandom(config.sizes);
  star.style.color = `rgb(${color})`;
  star.style.textShadow = `0px 0px 1.5rem rgb(${color} / 0.5)`;
  star.style.animationName = config.animations[count++ % 3];
  star.style.starAnimationDuration = ms(config.starAnimationDuration);

  appendElement(star);

  removeElement(star, config.starAnimationDuration);
};

const determinePointQuantity = (distance) =>
  Math.max(Math.floor(distance / config.maximumGlowPointSpacing), 1);

const updateLastStar = (position) => {
  last.starTimestamp = new Date().getTime();

  last.starPosition = position;
};

const updateLastMousePosition = (position) => (last.mousePosition = position);

const adjustLastMousePosition = (position) => {
  if (last.mousePosition.x === 0 && last.mousePosition.y === 0) {
    last.mousePosition = position;
  }
};

const handleOnMove = (e) => {
  const mousePosition = { x: e.clientX, y: e.clientY };

  adjustLastMousePosition(mousePosition);
  const now = new Date().getTime(),
    hasMovedFarEnough =
      calcDistance(last.starPosition, mousePosition) >=
      config.minimumDistanceBetweenStars,
    hasBeenLongEnough =
      calcElapsedTime(last.starTimestamp, now) > config.minimumTimeBetweenStars;

  if (hasMovedFarEnough || hasBeenLongEnough) {
    createStar(mousePosition);

    updateLastStar(mousePosition);
  }

  updateLastMousePosition(mousePosition);
};

window.onmousemove = (e) => handleOnMove(e);

window.addEventListener('touchmove', function(e) {
  handleOnMove(e.touches[0])
}, { passive: true });

document.body.onmouseleave = () => updateLastMousePosition(originPosition);
